import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { map, Observable } from 'rxjs';

import { Mxa710DeviceUiDeviceBehaviorPlugin } from '@shure/device-ui/shared/device-behavior';
import { DeviceUiPage, DeviceUiRoute } from '@shure/device-ui/shared/services';
import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';

@Injectable()
export class Mxa710CdmDeviceBehaviorPlugin extends Mxa710DeviceUiDeviceBehaviorPlugin {
	constructor(transloco: TranslocoService) {
		super(transloco);
	}

	public override getAvailablePages$(
		_model: DeviceModel,
		_options?:
			| {
					virtual?: boolean | undefined;
					autoCoverageMode?: boolean | undefined;
					dspSettingsPageEnabled?: boolean;
			  }
			| undefined
	): Observable<DeviceUiPage[] | undefined> {
		return this.transloco.selectTranslate('scCdmSharedDevBehavior.toolbar.labels.settings').pipe(
			map((settingsLabel) => {
				return [
					{
						route: DeviceUiRoute.Settings,
						label: settingsLabel
					}
				];
			})
		);
	}

	public override getDefaultRoute(): DeviceUiRoute {
		return DeviceUiRoute.Settings;
	}
}
